import script from "./MasterServerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MasterServerModal.vue?vue&type=script&setup=true&lang=ts"

import "./MasterServerModal.vue?vue&type=style&index=0&id=63638796&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63638796"]])

export default __exports__